module.exports = __webpack_public_path__ + "img/coins-balance-bg.3a1fb34c.png";